import { IBusinessFull } from "./businessFull.interface";

/** Mirrors PppRedirectPage in the backend's shared/types/pppLink.interface.ts. */
export enum PppRedirectPage {
  Receipt = "receipt",
  ReviewMock = "review-mock",
  Review = "review",
  Loyalty = "loyalty",
  Subscription = "subscription",
  TableOrder = "table-order",
  PaymentResultPending = "payment-result-pending",
}

/** Mirrors PppLinkOriginType in the backend's shared/types/pppLink.interface.ts. */
export enum PppLinkOriginType {
  NfcBracelet = "nfc_bracelet",
  NfcSticker = "nfc_sticker",
  NfcCoaster = "nfc_coaster",
  NfcTableCard = "nfc_table_card",
  QrApp = "qr_app",
  QrTable = "qr_table",
}

export interface IPppLinkMetadata {
  transactionId?: string;
  amount?: number;
  currency?: string;
  customerId?: string;
}

export interface IPppLinkObject {
  _id: string;
  code: string;
  businessId: IBusinessFull | string;
  redirectPage: PppRedirectPage;
  originType: PppLinkOriginType;
  metadata?: {
    transactionId?: string;
    amount?: number;
    currency?: string;
    customerId?: string;
  };
  fullUrl: string;
  expiresAt?: string | Date;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

// POST /ppp-links
export interface CreatePppLinkRequestBody {
  businessId: string;
  redirectPage: PppRedirectPage;
  originType: PppLinkOriginType;
  metadata?: {
    transactionId?: string;
    amount?: number;
    currency?: string;
    customerId?: string;
  };
  expiresAt?: string;
}
export interface CreatePppLinkResponse {
  link: IPppLinkObject;
}

// GET /ppp-links
export interface GetPppLinksQuery {
  businessId?: string;
  search?: string;
  originType?: PppLinkOriginType;
  redirectPage?: PppRedirectPage;
}
export interface GetPppLinksResponse {
  links: IPppLinkObject[];
}

// DELETE /ppp-links/{code}
export interface DeletePppLinkPath {
  code: string;
}
export interface DeletePppLinkResponse {
  status: "deleted";
}

// PUT /ppp-links/{pppLinkId}
export interface UpdatePppLinkPath {
  pppLinkId: string;
}
export interface UpdatePppLinkResponse {
  link: IPppLinkObject;
}
